import { render, staticRenderFns } from "./selectTypes.vue?vue&type=template&id=496f7239&scoped=true&"
import script from "./selectTypes.vue?vue&type=script&lang=js&"
export * from "./selectTypes.vue?vue&type=script&lang=js&"
import style0 from "./selectTypes.vue?vue&type=style&index=0&id=496f7239&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496f7239",
  null
  
)

export default component.exports